import { ButtonIcon } from '@qualtrics/ui-react/icons';
import comparator from '../commonComparators/caseInsensitive';
import { highlightSearch } from '../highlighters/highlightSearch';

/**
 * @type {CommandPalettePlugin}
 */
export const pbaPlugin = {
  visExp: 'true',
  id: 'pbaPlugin',
  getResults: async ({ portals: portalsInfo }) => {
    return (searchString) =>
      Promise.resolve(
        portalsInfo.portals
          .filter((portal) => comparator(portal.name, searchString))
          .map((portal) => ({
            label: highlightSearch(portal.name, searchString),
            searchLabel: portal.name,
            itemId: portal.id,
            action: () => {
              window.location.href = portal.homeHref;
            },
            icon: {
              Icon: ButtonIcon,
            },
          })),
      );
  },
};
